import { c as _c } from "react/compiler-runtime";
import { classNames, FlexCenter, Media, SkeletonLine, TextLabel } from "@opensea/ui-kit";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslations } from "use-intl";
import { BestOfferButton } from "./BestOfferButton";
import { SetPriceInput } from "./SetPriceInput";
export const CreateOfferFlowHeaderActions = t0 => {
  const $ = _c(16);
  const {
    className,
    offerSymbol
  } = t0;
  const t = useTranslations("wallet.CreateOfferFlowHeaderActions");
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== control) {
    t1 = {
      control,
      name: "offers"
    };
    $[0] = control;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const offers = useWatch(t1);
  let t2;
  if ($[2] !== className) {
    t2 = classNames("gap-3 md:mr-10 xl:mr-0", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== offers.length || $[5] !== t) {
    t3 = t("setPriceTo", {
      count: offers.length
    });
    $[4] = offers.length;
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <Media greaterThanOrEqual="md"><TextLabel className="whitespace-nowrap" size="2xs">{t3}</TextLabel></Media>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <BestOfferButton />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== offerSymbol) {
    t6 = <SetPriceInput offerSymbol={offerSymbol} />;
    $[10] = offerSymbol;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t4 || $[14] !== t6) {
    t7 = <FlexCenter className={t2}>{t4}{t5}{t6}</FlexCenter>;
    $[12] = t2;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export const CreateOfferFlowHeaderActionsSkeleton = t0 => {
  const $ = _c(12);
  const {
    className,
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  const t = useTranslations("wallet.CreateOfferFlowHeaderActions");
  let t2;
  if ($[0] !== className) {
    t2 = classNames("gap-3 md:mr-10 xl:mr-0", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== count || $[3] !== t) {
    t3 = t("setPriceTo", {
      count
    });
    $[2] = count;
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <Media greaterThanOrEqual="md"><TextLabel className="whitespace-nowrap" size="2xs">{t3}</TextLabel></Media>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <SkeletonLine className="h-8 w-full md:w-[68px]" />;
    t6 = <SkeletonLine className="h-8 w-full md:w-[120px]" />;
    $[7] = t5;
    $[8] = t6;
  } else {
    t5 = $[7];
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t2 || $[10] !== t4) {
    t7 = <FlexCenter className={t2}>{t4}{t5}{t6}</FlexCenter>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};